export enum EAddImageMenuState {
  ImageUrl = 'upload-image',
  ImageUpload = 'image-from-url',
}
